import { PartialType, PickType } from '@nestjs/swagger';
import { SubdivisionUpdatableInterface } from '../interfaces/subdivision-updatable.interface';
import { SubdivisionDto } from './subdivision.dto';

export class SubdivisionUpdateDto
  extends PartialType(
    PickType(SubdivisionDto, [
      'name',
      'address1',
      'address2',
      'city',
      'state',
      'zip',
      'archived',
      'builderId',
      'regionId',
      'active',
      'reqBumpoutTimesheet',
      'warrantyStatus',
      'overrideRegionCostPerBoard',
      'allowPayoutAmountEditing',
      'garageCostFixed',
      'specialJobsPercentage',
      'dwHangingCostPerBoard',
      'dwFinishingCostPerBoard',
      'dwSprayingCostPerBoard',
      'pieceworkPercentage',
      'highCeilingPerBoard',
      'screwInspectionPerBoard',
      'screwInspectionPerBoard',
      'dwpHangingCostPerBoard',
      'dwpFinishCostPerBoard',
      'dwpPrimeCostPerSqft',
      'dwpBump1CostPerBoard',
      'dwpTrim1CostPerSqft',
      'dwpInteriorPaintCostPerSqft',
      'dwpBump2CostPerBoard',
      'dwpTrim2CostPerSqft',
      'dwpFinalPaintCostPerSqft',
      'dwpBump3CostPerBoard',
      'dwpCMBluetapeCostPerSqft',
      'dwpFinalBluetapeCostPerSqft',
      'interiorOptionsPercentage',
      'exteriorOptionsPercentage',
      'trimOptionPercentage',
      'exteriorOnePercentage',
      'exteriorTwoPercentage',
      'overrideType',
      'geoDistanceTolerance',
    ]),
  )
  implements SubdivisionUpdatableInterface {}
